import { FC } from 'react';
/* Icons */
import ErrorIcon from '@mui/icons-material/Error';

import { GridRenderCellParams } from '@mui/x-data-grid-premium';

import { IconButton, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  SStack,
  SValue,
} from '../../../../../../common/orderGridItems/cells/product/product.cell.tsx';
import { localeFormatterHelper } from '../../../../../../../../shared/helpers/formatter/localeFormatter.helper.ts';
import { useTranslation } from 'react-i18next';

export const QuantityCell: FC<IQuantityCell> = ({ params }) => {
  const { t } = useTranslation();
  const { value, row } = params;
  return (
    <SStack>
      <>
        <div>
          {row.error && (
            <STooltip title={<span>{t('common.saving_error_try_again')}</span>} arrow>
              <SIconButton
                tabIndex={-1}
                onClick={(e) => e.stopPropagation()}
                color='error'
                size='small'
              >
                <ErrorIcon />
              </SIconButton>
            </STooltip>
          )}
        </div>
        <SValue>
          {localeFormatterHelper.formatNumber(value || '', {
            noTrailingZeros: true,
            returnZero: false,
            precision: 3,
          })}
        </SValue>
      </>
    </SStack>
  );
};

const SIconButton = styled(IconButton)(() => ({
  padding: 3,
  svg: {
    fontSize: 18,
  },
}));

const STooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 'none',
  },
});

interface IQuantityCell {
  params: GridRenderCellParams;
}
